import React from 'react';
import { KeyRound } from 'lucide-react';

import { Tag, TagProps } from './Tag';
import { TAG_VARIANTS } from './variants';

export interface RequestGroupTagProps extends Omit<TagProps, 'text'> {
  createdBy: 'self' | 'other';
  showIcon?: boolean;
}
export function RequestGroupTag({
  createdBy,
  showIcon = true,
  backgroundColor,
  textColor,
  className,
  onClick
}: RequestGroupTagProps) {
  const variant =
    createdBy === 'self' ? TAG_VARIANTS.IN_PROGRESS : TAG_VARIANTS.BY_OTHER;
  const text = variant.text ?? '';
  const defaultBg = variant.backgroundColor ?? '#191F2E14';
  const defaultColor = (variant.textColor ?? 'default') as string;

  return (
    <Tag
      text={text}
      backgroundColor={backgroundColor ?? defaultBg}
      textColor={textColor ?? defaultColor}
      icon={
        showIcon && createdBy === 'self' ? (
          <KeyRound className="w-3 h-3" />
        ) : undefined
      }
      className={className}
      onClick={onClick}
    />
  );
}
